import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import logo1 from '../../assests/logo1.png'
import passwordService from '../../api/services/passwordService'

const ForgotPassword = () => {
  const [email, setEmail] = useState("")
  const navigate = useNavigate()
  const [message, setMessage] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleForgotPassword = async (e) => {
    e.preventDefault()

    if (!email) {
      setError("Please enter your email")
      return
    }

    setLoading(true)
    setError(null)
    setMessage(null)

    try {
      const response = await passwordService.forgotPassword({ email })
      console.log(response)
      if (response.responseCode === 200) {
        toast.success(response?.message)
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='flex items-center justify-center min-h-screen bg-[#F2F6FA] p-4'>
      <div className='w-full max-w-[560px]'>
        <div className='flex flex-col items-center mb-6'>
          <img src={logo1} alt="Naseebi" className='h-14 w-auto' />
        </div>

        <div className='bg-white rounded-2xl shadow-[0_10px_30px_rgba(0,0,0,0.08)] px-8 py-10'>
          <h1 className='text-[#0F172A] text-[30px] leading-none font-[700] text-center mb-8'>Forgot Password</h1>

          <div className='space-y-6'>
            <div>
              <label className='block text-[15px] font-[600] text-gray-700 mb-2'>Email *</label>
              <input
                onChange={(e) => setEmail(e.target.value)}
                type='email'
                placeholder='Enter your email'
                className='w-full h-12 rounded-lg border border-gray-200 px-4 focus:outline-none focus:ring-2 focus:ring-[#FB565F] focus:border-transparent placeholder:text-gray-400'
              />
            </div>

            <button
              className='w-full h-12 rounded-lg bg-[#FB2F38] hover:bg-[#e42831] text-white font-[700] tracking-wide transition-colors flex items-center justify-center'
              onClick={handleForgotPassword}
              disabled={loading}
            >
              {loading ? (
                <>
                  <svg
                    className="animate-spin h-5 w-5 mr-2 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                  Sending...
                </>
              ) : (
                'Send reset link'
              )}
            </button>

            <div className='text-center'>
              <button
                type='button'
                onClick={() => navigate('/login')}
                className='text-[#D12A30] text-sm font-[600] hover:underline'
              >
                Back to login
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
